// extracted by mini-css-extract-plugin
export default {"container":"FooterPricing_container__x-gsP","btn":"FooterPricing_btn__l9kgD"};